import * as React from 'react';

import { ConfirmPopoverButton } from '../../ConfirmPopoverButton';
import { DeleteButtonCellProps } from '../types';

import { useTranslations } from '~/modules/trade/i18n/useTranslations';
import { DeleteButtonCell as SharedDeleteButton } from '~/shared/components/line-items';

export interface ExtendedDeleteButtonCellProps extends DeleteButtonCellProps {
  confirmationType?: 'salesOrderLoad' | 'standaloneLoad';
}

export const DeleteButtonCell: React.FC<ExtendedDeleteButtonCellProps> = ({
  lineItem,
  disabled = false,
  onDeleteLineItem,
  confirmationType = 'standaloneLoad',
}) => {
  const t = useTranslations();

  const itemName = React.useMemo(
    () => lineItem.item?.name || 'Unknown Item',
    [lineItem.item],
  );

  const { title, message } = React.useMemo(() => {
    if (confirmationType === 'salesOrderLoad') {
      return {
        title: t.deleteLineItemConfirmation.salesOrderLoadTitle(itemName),
        message: t.deleteLineItemConfirmation.salesOrderLoadMessage(itemName),
      };
    }
    return {
      title: t.deleteLineItemConfirmation.standaloneLoadTitle(itemName),
      message: t.deleteLineItemConfirmation.standaloneLoadMessage(itemName),
    };
  }, [confirmationType, itemName, t]);

  const handleDelete = React.useCallback(() => {
    onDeleteLineItem(lineItem.id);
  }, [lineItem.id, onDeleteLineItem]);

  if (!lineItem.itemId) {
    return (
      <SharedDeleteButton
        onDelete={handleDelete}
        disabled={disabled}
        className="@DeleteButtonCell"
      />
    );
  }

  return (
    <ConfirmPopoverButton
      onConfirm={handleDelete}
      title={title}
      message={message}
      confirmLabel={t.deleteLineItemConfirmation.confirm}
      className="@DeleteButtonCell"
      contentClassName="max-w-95"
      renderTrigger={() => (
        <SharedDeleteButton disabled={disabled} className="@DeleteButtonCell" />
      )}
    />
  );
};
